/**
 * /version — شماره‌ی انتشارِ همین بیلدِ وب، بی ورود.
 *
 * تسترِ دستی پیش از هر سناریوی دورِ یک تیکت این را با شماره‌ای که صفحه‌ی QA
 * می‌خواهد مقایسه می‌کند (qa_tickets.build، مایگریشن 0173) — قرینه‌ی سطرِ پایینِ
 * تنظیماتِ اپ. پروفایل هم همین را نشان می‌دهد ولی پشتِ ورود است.
 */
import React from 'react';
import { BUILD_STAMP } from '@/core/lib/buildInfo';

export function VersionPage() {
  return (
    <div style={{ padding: '48px 16px', textAlign: 'center' }}>
      <p className="dim">WhosUp</p>
      <h1 style={{ fontSize: 28, margin: '8px 0', direction: 'ltr' }}>{BUILD_STAMP || '—'}</h1>
      <p className="dim" style={{ fontSize: 12 }}>{location.host}</p>
    </div>
  );
}
